/**
 * Onboarding funnel vocabulary. FROZEN — these strings and indices are the wire format shared
 * with the Flutter app's GA4 property. Renaming one does not rename it in GA4; it forks the funnel
 * into a new step and silently splits every conversion rate. On-screen copy can change freely.
 *
 * Source of truth: the app's `lib/services/analytics.dart`.
 */
export interface Step {
  /** Funnel position. The furthest-page guard compares these. */
  page: number;
  /** The `step` / `from` parameter value on the wire. */
  wire: string;
}

export const STEPS: readonly Step[] = [
  { page: 0, wire: 'welcome' },
  { page: 1, wire: 'business' },
  { page: 2, wire: 'location' },
  { page: 3, wire: 'signature' },
  { page: 4, wire: 'product' },
  { page: 5, wire: 'plan' },
  { page: 6, wire: 'done' },
] as const;

export const STEP = {
  welcome: STEPS[0]!,
  business: STEPS[1]!,
  location: STEPS[2]!,
  signature: STEPS[3]!,
  product: STEPS[4]!,
  plan: STEPS[5]!,
  done: STEPS[6]!,
} as const;

/**
 * Blocked reasons. snake_case, describing what was wrong rather than where.
 *
 * The `cert_*` values are camelCase after the prefix because they are a Dart enum's `.name` in the
 * app. Ugly, but shipped: matching them is what lets the two streams merge into one funnel.
 */
export const BLOCKED = {
  businessFormInvalid: 'business_form_invalid',
  noBranchSelected: 'no_branch_selected',
  establecimientoFormInvalid: 'establecimiento_form_invalid',
  puntoFormInvalid: 'punto_form_invalid',
  noP12Selected: 'no_p12_selected',
  noP12Password: 'no_p12_password',
  certNotAuthenticated: 'cert_notAuthenticated',
  certEmisorNotConfigured: 'cert_emisorNotConfigured',
  certUploadFailed: 'cert_uploadFailed',
  certNotUploaded: 'cert_notUploaded',
  certRucLocked: 'cert_rucLocked',
  certError: 'cert_error',
} as const;

export type BlockedReason = (typeof BLOCKED)[keyof typeof BLOCKED];
